//
//
//
//
//
//
//
//
//
//

/**
 * mt-tab-item
 * @module components/tab-item
 * @desc 搭配 tabbar 或 navbar 使用
 * @param {*} id - 选中后的返回值，任意类型
 * @param {slot} [icon] - icon 图标
 * @param {slot} - 文字
 *
 * @example
 * <mt-tab-item>
 *   <img slot="icon" src="http://placehold.it/100x100">
 *   订单
 * </mt-tab-item>
 */

/**
 * @noteType component
 * @name TabItem
 * @tagName mt-tab-item
 * @desc 选项卡头节点
 * @type tabItem
 * @wrapClassName mint-tab-item
 * @uniqueKey id
 * @noDisplayInComponents true
 * @html
 * <mt-tab-item id="1">{{space}}</mt-tab-item>
 */
export default {
  name: 'mt-tab-item',
  data: function(){
    return {
      itemwidth:''
    }
  },

    /**
     * @noteType prop
     * @field id
     * @desc id
     * @type input
     * @value
     */
  props: {
    id:String,
    icontype:String,
    componentname:{
      type:String,
      default:"tab"
    }
  },
  computed:{
    labelClassObject: function() {
      let _class='';
      switch(this.componentname){
        case 'tab': _class="mt-color-grey-lv3";break;
        case 'navbar': _class="mt-color-grey-lv2";break;
        case 'sidenavbar': _class="mt-color-grey";break;
        default:
          _class="mt-color-grey-lv3";break;
      }
      return _class;
    },
    itemClassObject: function() {
      let _class='';
      if(this.$parent.value === this.id){
        _class += 'is-selected ';
        _class += this.componentname === 'navbar'?'mt-bColor-theme ':'';
        _class += this.componentname === 'sidenavbar'?'mt-bg-lv3':'';
      }
      return _class;
    }
  },
  mounted() {
    this.navbarWidth();
  },
  methods: {
    navbarWidth: function() {
      this.$nextTick(function(){
        if(this.componentname === 'navbar'){
          let len = this.$parent.$el.querySelectorAll('.mint-tab-item').length;
          let width = this.$parent.$el.offsetWidth
          len=len>5?5.5:len;
          this.$el.style.minWidth = width/len+"px";
        }
      });
    }
  }
};

/**
 * @noteType external
 * @content
 {
   "mock": {
      "space": "tab"
    },
    "textField": {
      "field": "space",
      "className": "mint-tab-item-label"
    }
 }
 */



// WEBPACK FOOTER //
// ./packages/tab-item/src/tab-item.vue